module.exports = __webpack_public_path__ + "static/media/lkw-12t.5af8e672.svg";